// PULSE branded login. Loaded on every website page via web_include_js, but it
// only activates on /login. It moves Frappe's existing login form (with all its
// event handlers intact) into a two-column PULSE layout, so all login logic —
// password login, forgot password, email-link login — keeps working untouched.
(function () {
	function isLoginPath() {
		var p = (location.pathname || '').replace(/\/+$/, '');
		if (p === '/login' || p === '/login/index') return true;
		// Frappe serves the login sections via hash routing (e.g. "/#login"),
		// so also activate when the hash or the login markup says so.
		if ((location.hash || '').toLowerCase().indexOf('login') > -1) return true;
		return !!document.querySelector('section.for-login');
	}

	function brandPanel() {
		return [
			'<div class="pulse-auth-brand">',
			'  <div class="pa-glow pa-glow-1"></div>',
			'  <div class="pa-glow pa-glow-2"></div>',
			'  <div class="pa-logo">',
			'    <div class="pa-logo-mark">',
			'      <svg width="23" height="23" viewBox="0 0 24 24" fill="none">',
			'        <path d="M6.5 7v10M17.5 7v10M3.5 9.5v5M20.5 9.5v5M6.5 12h11" stroke="#fff" stroke-width="2.2" stroke-linecap="round"></path>',
			'      </svg>',
			'    </div>',
			'    <span class="pa-logo-text">PULSE<span>.</span></span>',
			'  </div>',
			'  <div class="pa-hero">',
			'    <div class="pa-badge">GYM MANAGEMENT SUITE</div>',
			'    <h1>Run your gym like<br>a well-oiled machine.</h1>',
			'    <p>Members, subscriptions, classes, trainers and billing — one command center for every branch.</p>',
			'    <div class="pa-stats">',
			'      <div><div class="pa-stat-value">12k+</div><div class="pa-stat-label">Active members</div></div>',
			'      <div><div class="pa-stat-value">48</div><div class="pa-stat-label">Gyms onboarded</div></div>',
			'      <div><div class="pa-stat-value">99.9%</div><div class="pa-stat-label">Uptime</div></div>',
			'    </div>',
			'  </div>',
			'  <div class="pa-footer">\u00A9 2026 PULSE \u00B7 v0.0.1 — Powered by your gym</div>',
			'</div>'
		].join('');
	}

	function decorateLoginHead() {
		var head = document.querySelector('.for-login .page-card-head');
		if (!head || head.dataset.pulseDone) return;
		head.dataset.pulseDone = '1';
		var h4 = head.querySelector('h4');
		if (h4) h4.textContent = 'Welcome back \uD83D\uDC4B';
		if (!head.querySelector('.pa-subtitle')) {
			var sub = document.createElement('p');
			sub.className = 'pa-subtitle';
			sub.textContent = 'Sign in to your PULSE workspace to continue.';
			head.appendChild(sub);
		}
	}

	function build() {
		if (document.querySelector('.pulse-auth')) return true;

		var anchor = document.querySelector('section.for-login');
		if (!anchor) return false;

		var formWrap = anchor.parentElement; // wraps every login/forgot/signup section
		if (!formWrap) return false;

		document.body.classList.add('pulse-login-page');

		var root = document.createElement('div');
		root.className = 'pulse-auth';
		root.innerHTML =
			brandPanel() +
			'<div class="pulse-auth-form"><div class="pulse-auth-inner"></div></div>';

		document.body.appendChild(root);
		// Move the real form node so its bound event handlers travel with it.
		root.querySelector('.pulse-auth-inner').appendChild(formWrap);

		decorateLoginHead();
		return true;
	}

	function init() {
		if (!isLoginPath()) return;
		if (build()) return;
		// Script may run before the form markup is parsed; retry briefly.
		var tries = 0;
		var t = setInterval(function () {
			tries++;
			if (build() || tries > 60) clearInterval(t);
		}, 60);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
